import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { PageComponent, ICC_PAGE_DATA } from '@icc/configurator/shared';

import { FormGroup, UntypedFormControl } from '@angular/forms';
import { MeasurementsService } from '../modules/dimensions/measurements.service';


@Component({
    selector: 'icc-dimensions-additional-data-page',
    templateUrl: './dimensions-additional-data-page.component.html',
    styleUrls: ['./dimensions-additional-data-page.component.scss'],
    standalone: false
})
export class DimensionsAdditionalDataPageComponent extends PageComponent implements OnInit,OnDestroy {
    public title: string = _('WINDOW|Zdjęcia i notatki');

    currentMeasurement: number;

    notesForm = new UntypedFormControl('');
    filesForm = new UntypedFormControl('');
    attachments: any[] = [];

    constructor(
        @Inject(ICC_PAGE_DATA) private pageData: any,
        private measurementsService: MeasurementsService
    ) {
        super();
        this.currentMeasurement = this.pageData.currentMeasurement;
        this.loadAttachments();
    }

    addFiles($event) {
        this.measurementsService.addFiles($event, this.currentMeasurement).then(() => {
            this.loadAttachments();
        });
    }

    downloadFile(file: any) {
        this.measurementsService.downloadFile(file);
    }

    removeFile(index: number) {
        this.measurementsService.removeFile(index, this.currentMeasurement);
    }

    ngOnInit() {
        this.notesForm.setValue(this.measurementsService.measurements[this.currentMeasurement].notes);
    }

    ngOnDestroy() {
        this.measurementsService.measurements[this.currentMeasurement].notes = this.notesForm.value;
    }

    loadAttachments() {
        this.attachments = this.measurementsService.measurements[this.currentMeasurement]?.attachments || [];
    }
}
